<div class="modal-backdrop" (click)="onClose()"></div>
<div class="recategorize-modal-container" #modalContainer (click)="$event.stopPropagation()">
    <div class="modal-content">
        <h3 class="modal-title">Recategorize Item</h3>
        <div class="modal-subheader">Move this line item to a different template category</div>
        <app-template-item-search-select
                [state]="state"
                [excludeItemId]="row?.categorizedTo ?? null"
                [validationOnly]="isValidation"
                (itemSelected)="onItemSelected($event)"
        ></app-template-item-search-select>
    </div>
</div>
